import React, { Component } from 'react';
import { map, findKey, truncate } from 'lodash';
import { timeSince } from '../../helpers';
import { appBasePath } from '../../constants/staticData';

export default class WaitingList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentId: null,
      // allData: props.allData,
      currentData: props.data,
    };
    this.windowWidth = this.windowWidth.bind(this);
  }
  componentWillMount() {
    this.setState({ allData: this.props.allData, currentData: this.props.data });
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ allData: nextProps.allData, currentData: nextProps.data });
  }
  windowWidth() {
    let docElemProp = window.document.documentElement.clientWidth,
      body = window.document.body;
    return window.document.compatMode === "CSS1Compat" && docElemProp || body && body.clientWidth || docElemProp;
  }
  render() {
    const currentData = this.props.data;
    let serviceType = 'repair';
    if (currentData.serviceId) {
      switch (currentData.serviceId) {
        case 1: {
          serviceType = 'wash';
          break;
        }
        case 2: {
          serviceType = 'service';
          break;
        }
        case 3: {
          serviceType = 'repair';
          break;
        }
      }
    }
    let date = new Date(currentData.createdAt);
    let seconds = Math.floor((new Date() - date) / 1000);
    // let interval = Math.floor(seconds / 3600);
    // if (interval > 23) {
    if (seconds > 82800) {
      let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      let createdAt = currentData && new Date(currentData.createdAt);
      date = months[createdAt.getMonth()] + ' ' + createdAt.getDate() + ' , ' + createdAt.getFullYear();
    } else {
      date = timeSince(new Date(new Date(currentData.createdAt).getTime())) + ' Ago';
    }
    const windowWidth = this.windowWidth();
    return (
      <div>
        <div onClick={() => { windowWidth < 992 ? this.props.router.push(`${appBasePath}/job/${currentData.id}`) : this.props.onCardClick(currentData.id);}}>
          <div className={"result-card status-card mhide " + serviceType}>
            <ul className="list-unstyled">
              <li className="age-data">
                <div className="result-card-title">
                  <label>{date}</label>
                </div>
                {currentData.isurgentrequest && <div className="result-card-status-icon">
                  <i className="mdi mdi-timer-sand" />
                </div>}
              </li>
              <li className="quote-data">
                {currentData.quotesreceived}
              </li>
              <li className="job-data">
                <label>  {currentData.requestid} {(currentData.vehicles && currentData.vehicles.carmodel && currentData.vehicles.carmake)? currentData.vehicles.carmake + ' ' + currentData.vehicles.carmodel : ''}<br />
                  {currentData.userbookingrequest_services.length && currentData.userbookingrequest_services[0].name}
                  {currentData.userbookingrequest_services.length > 1 && ' + ' + (currentData.userbookingrequest_services.length - 1) + ' More'}
                </label>
                {/* <span> {Object.keys(currentData.repairType.repair)[0]} {" ," + Remainig + " More"} </span> */}
              </li>
              <li className="area-data">
                {truncate(currentData.location)}
              </li>
            </ul>
          </div>
          <div className={"result-card status-card mshow " + serviceType}>
            <ul className="list-unstyled">
              <li>
                <label>
                  AGE
                </label>
                <span>
                  <div className="result-card-title">
                    <label>{timeSince(new Date(new Date(currentData.createdAt).getTime())) + ' Ago'}</label>
                  </div>
                  {currentData.emergencyIcon && <div className="result-card-status-icon">
                    <i className="mdi mdi-timer-sand" />
                  </div>}
                </span>
              </li>
              <li>
                <label>
                  QUOTES RECEIVED
                    </label>
                <span>
                  {currentData.quotesreceived}
                </span>
              </li>
              <li className="job-data">
                <label>JOB ID / DETAILS</label>
                <span>
                  {currentData.requestid}
                  <span className="display-block">
                    {currentData.userbookingrequest_services.length && currentData.userbookingrequest_services[0].name}
                    {currentData.userbookingrequest_services.length > 1 && ' + ' + currentData.userbookingrequest_services.length + ' More'}
                  </span>
                </span>
              </li>
              <li className="job-data">
                <label>AREA</label>
                <span>  {currentData.location} </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StatusList/WaitingList.jsx